import { LoadingController } from '@ionic/angular';
import { Injectable } from '@angular/core';

import { SettingsProvider } from '../settings/settings';
import { AlertProvider } from '../alert/alert';
import * as moment from 'moment';
import { HelperProvider } from '../helper/helper';
import { LoadingProvider } from '../loading/loading';
import { Router } from '@angular/router';

import { SharedDataProvider } from '../shared-data/shared-data';
import { HttpHeaders } from '@angular/common/http';
const qs = require('qs');
const axios = require('axios').default;

let mblClient = axios.create({
  // baseURL: 'http://127.0.0.1:3333/api/v1/',
  baseURL: 'https://mbl4on4.parity.gr',
});

@Injectable()
export class MblRestProvider {
  loadings = [];
  constructor(
    public sharedData: SharedDataProvider,
    public settings: SettingsProvider,
    public helper: HelperProvider,
    public loadingController: LoadingController,
    public loadingProv: LoadingProvider,
    public alertprov: AlertProvider
  ) {
    let that = this;
    mblClient.interceptors.request.use(
      async function (config) {
        // await that.refreshToken()
        let loading = await that.loadingController.create({
          message: 'Παρακαλώ Περιμένετε...',
        });
        await loading.present();
        that.loadings.push({
          url: config.url,
          loading: loading,
        });
        // config.headers['AppVersion'] = await helper.getAppVersion();
        //config.headers['Authorization'] = 'Bearer ' + (await this.getToken());

        return config;
      },
      function (error) {
        console.error(error);
        return Promise.reject(error);
      }
    );
    mblClient.interceptors.response.use(
      function (response) {
        // console.log('got response');
        let url = response.config.url.replace(response.config.baseURL, '');
        let loading = that.loadings.find((l) => l.url == url);
        let ind = that.loadings.indexOf(loading);
        loading.loading.dismiss();
        that.loadings.splice(ind, 1);
        return response.data;
      },
      async function (error) {
        // console.log('got error');
        // console.log(error);

        //handles hide loading
        let url = error.config.url.replace(error.config.baseURL, '');
        let loading = that.loadings.find((l) => l.url == url);
        let ind = that.loadings.indexOf(loading);
        loading.loading.dismiss();
        that.loadings.splice(ind, 1);

        switch (error.response.status) {
          case 400:
            // TODO: may if critical
            that.alertprov.showError(error.response.data.message);
            break;
          case 401:
            console.error('un-authorised user...');

            let originalRequest = error.config;
            if (!originalRequest._retry) {
              console.error('refreshing token...');
              originalRequest._retry = true;
              await that.refreshToken();
              // axios.defaults.headers.common['Authorization'] = 'Bearer ' + await this.getToken()
              let tkn = await that.getToken();
              // console.log(tkn);
              originalRequest.headers.common['Authorization'] = 'Bearer ' + tkn;
              return mblClient(originalRequest);
            } else {
              that.alertprov.showError(
                'Αδυναμία ταυτοποίησης χρήστη.Παρακαλώ προσπαθήστε ξανά.'
              );
            }
            // that.sharedData.logOut()
            break;
          case 500:
            that.alertprov.showError('Εσωτερικό σφάλμα εξυπηρετητή.');
            break;
          default:
            break;
        }
        return Promise.reject(error.response.data);
      }
    );
  }

  async refreshToken() {
    let refresh = await mblClient.post(
      'refresh',
      {
        refresh_token: await this.settings.get('refresh_token'),
      },
      {}
    );
    // console.log(refresh);
    await this.settings.set('access_token', refresh.access_token);
    await this.settings.set('refresh_token', refresh.refresh_token);
    // await this.settings.set("isLogged", true)
    // await this.helper.openStartPage()
  }
  async login(Email, Password) {
    let login = await mblClient.post(
      'login',
      {
        email: Email,
        password: Password,
      },
      {}
    );
    // console.log(login);
    await this.settings.set('access_token', login.token);
    await this.settings.set('refresh_token', login.refreshToken);
    await this.settings.set('isLogged', true);
    this.sharedData.isLogged = true;
  }
  async register(Email, Password, Password2) {
    let register = await mblClient.post(
      'register',
      {
        email: Email,
        password: Password,
        password_retype: Password2,
      },
      {}
    );
  }
  async logOut() {
    // console.log('logging out user ....');
    await this.settings.set('access_token', '');
    await this.settings.set('refresh_token', '');
    await this.settings.set('isLogged', false);
    this.sharedData.isLogged = false;

    await this.helper.openStartPage();
  }
  async getToken() {
    return this.settings.get('access_token');
  }
  async syncData(game) {
    return mblClient.post(
      'sync-stats',
      {
        game: game,
      },
      {}
    );
  }
}
